import { Navigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie";
const ProtectedLoginRoute = () => {
  let token = Cookies.get("F&ftToken");
  return !token ? <Outlet /> : <Navigate to="/home" />;
};
export default ProtectedLoginRoute;
